import React from 'react';
import styles from './styles';
import {Form} from "@xpertdox_js/xdcomponents";
import {colors} from '@xpertdox_js/xdstyle'

const AgeEdit = props => {
    const [formState, setFormState] = React.useState({test: true});
    const submit = (value) => console.log(value)
    const id = 'editField_'+props.id+'_display';
    const show = props.formState['editField_'+props.id] === '<1';
    const changeState = state => {
        console.log(props.formState, state, "STATE")
        let newState = {...props.formState, ...state};
        props.setManualHasChanged(true);
        props.setFormState(newState);
        props.setDiff(props.id+'Display', state['editField_'+props.id+'_display'])

    }
    if(show) return(
        <div style={{...props.styles.container, padding: 0}}>
            <h4 style={props.styles.heading}>{props.title}</h4>
            <Form
                state={{formState: props.formState, setFormState: changeState}}
                settings={[{
                    id,
                    type: 'number',
                    value: props.value || '',
                }]}
                styles={{submit: {display: 'none'}}}
                handleChange={submit}
            />
            <p style={{color: colors.error, marginTop: '-8px', marginBottom: 8}}>*May not become available until next database update</p>
        </div>
    )
    else return null;
}


export default AgeEdit;
